import { useState } from "react"

import type { ProgressState } from "./types"

const determineState = (activeIndex: number, index: number): ProgressState => {
  if (activeIndex > index) return "complete"
  if (activeIndex === index) return "active"

  return "incomplete"
}

export const useProgressState = () => {
  const [activeStep, setActiveStep] = useState(0)

  return {
    getState: (index: number) => determineState(activeStep, index),
    onClick: (index: number) => () => setActiveStep(index),
    goToNextStep: () => setActiveStep(activeStep + 1),
    activeStep,
  }
}
